const rows = [
  { method: "Fast Passport Center (3-day)", processing: "3 business days", mailing: "Overnight FedEx return", total: "~5–6 days door to door", highlight: true },
  { method: "Fast Passport Center (4-day)", processing: "4 business days", mailing: "Overnight FedEx return", total: "~6–7 days door to door", highlight: true },
  { method: "Fast Passport Center (7-day)", processing: "7 business days", mailing: "Overnight FedEx return", total: "~9–11 days door to door", highlight: true },
  { method: "Government Expedited (DIY)", processing: "2–3 weeks", mailing: "+ up to 2 weeks each way", total: "6–10 weeks total", highlight: false },
  { method: "Government Routine (DIY)", processing: "4–6 weeks", mailing: "+ up to 2 weeks each way", total: "8–14 weeks total", highlight: false },
];

export default function HowFastComparisonSection() {
  return (
    <section className="py-16 md:py-20 bg-[#f7faf9]">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-[#1B4D3E] text-center mb-3">
          How Fast Can You Actually Renew Your Passport?
        </h2>
        <p className="text-gray-600 text-center mb-10 max-w-3xl mx-auto">
          Here's the honest comparison between your options. Government timelines are for processing only — they don't include mailing time, which adds 1–2 weeks on each end.
        </p>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse bg-white rounded-lg overflow-hidden border border-gray-200">
            <thead>
              <tr className="bg-[#1B4D3E] text-white text-sm">
                <th className="text-left py-3.5 px-4 md:px-6 font-semibold">Method</th>
                <th className="text-left py-3.5 px-4 md:px-6 font-semibold">Processing Time</th>
                <th className="text-left py-3.5 px-4 md:px-6 font-semibold hidden md:table-cell">Mailing Time</th>
                <th className="text-left py-3.5 px-4 md:px-6 font-semibold">Total Realistic Time</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i} className={`border-b border-gray-100 ${row.highlight ? "bg-green-50/50" : "bg-white"} hover:bg-gray-50 transition-colors`}>
                  <td className="py-3.5 px-4 md:px-6">
                    <span className={`text-sm md:text-base font-semibold ${row.highlight ? "text-[#1B4D3E]" : "text-gray-700"}`}>
                      {row.method}
                    </span>
                    {row.highlight && (
                      <span className="ml-2 inline-block px-2 py-0.5 rounded-full bg-green-100 text-[#1B4D3E] text-xs font-medium">
                        ✓
                      </span>
                    )}
                  </td>
                  <td className="py-3.5 px-4 md:px-6 text-sm md:text-base text-gray-700">{row.processing}</td>
                  <td className="py-3.5 px-4 md:px-6 text-sm md:text-base text-gray-700 hidden md:table-cell">{row.mailing}</td>
                  <td className="py-3.5 px-4 md:px-6 text-sm md:text-base font-semibold text-[#1B4D3E]">{row.total}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="mt-6 text-sm text-gray-500 text-center max-w-3xl mx-auto">
          Fast Passport Center processing time begins when we receive your documents. Add 1–2 days for your documents to reach us if mailing. All FPC tiers include overnight FedEx return delivery and real-time tracking.
        </p>
      </div>
    </section>
  );
}